module.exports = __webpack_public_path__ + "img/202010_review.1db74765.jpg";